import formatToCurrency from './formatToCurrency';

const formatCurrencyTemplate =
    (template: string, presicion = 2) =>
    (amount: string): string =>
        formatToCurrency(amount, presicion, template);

export default formatCurrencyTemplate;
